import React from 'react';
import { BookOpen, Target, Users, Trophy } from 'lucide-react';

const categories = [
  {
    title: "Funny Team Names",
    examples: ["Touchdown Trotters", "Pigskin Pandas", "Fantasy Fools"],
    description: "Humorous names that bring fun and laughter to your fantasy league."
  },
  {
    title: "Player-Based Names",
    examples: ["Mahomes Monarchy", "Brady's Brigade", "Allen's Army"],
    description: "Names that celebrate your favorite NFL players and their achievements."
  },
  {
    title: "Pop Culture References",
    examples: ["Game of Throws", "Gridiron Thrones", "Football Awakens"],
    description: "Names that combine football with popular movies, shows, and trends."
  }
];

const tips = [
  {
    icon: BookOpen,
    title: "Know Your League",
    content: "Consider your league's style and tone when choosing a name."
  },
  {
    icon: Target,
    title: "Stay Current",
    content: "Use references to current players and trending topics."
  },
  {
    icon: Users,
    title: "Be Original",
    content: "Avoid common names and create something unique."
  },
  {
    icon: Trophy,
    title: "Keep It Clean",
    content: "Ensure your name is appropriate for all league members."
  }
];

export default function FantasyFootballGuide() {
  return (
    <section className="py-20 bg-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Fantasy Football Team Names
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-green-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Choosing Your Fantasy Team Name
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-green-100 mb-4">
                  <tip.icon className="w-6 h-6 text-green-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}